<template>
  <div class="stockDeliverBox">
    <span>{{ title }}</span>
    <!-- <img v-if="avatar"  class="avatar-photo" id="profile_photo_blank" :src="avatar" />
    <img v-else class="avatar-photo" src="@/assets/images/blank_person.jpg" alt="" /> -->
    <div class="stockDeliverInnerBox">
      <div class="stockDeliverFrame">
        <span>
          <p>
            {{ $t("profile.stock.idTransporeon") }}
          </p>

          <span>{{ data.subId }}</span>
        </span>
        <!-- 
        <span>
          <p>{{ $t("profile.stock.car") }}</p>
          <span>{{ data.carType ? $t(`car_types.${data.carType.toLowerCase()}`) : "Dowolny" }}</span>
        </span>
        <span>
          <p>{{ $t("profile.stock.part") }}</p>
          <span>{{ data.carPart ? $t(`car_types.${data.carPart.toLowerCase()}`) : "Dowolny" }}</span>
        </span> -->

        <span>
          <p>{{ $t("profile.stock.license") }}</p>
          <span>{{ $t(`enums.${data.license}`) }}</span>
        </span>
        <!-- <span>
          <p>
            {{ $t("profile.stock.lastModifiedDate") }}
          </p>

          <span>{{ data.modifiedAt ? convertLongStringToDateAndHour(data.modifiedAt) : "-" }}</span>
        </span> -->
        <span>
          <p>{{ $t("profile.stock.deadline") }}</p>
          <span>{{ data.deadline ? convertLongStringToDateAndHour(data.deadline) : "-" }}</span>
        </span>
        <span v-if="data.surcharges && data.surcharges.length > 0">
          <p>{{ $t("tableData.surcharges") }}</p>
          <div class="initial-data">
            <div style="padding-left: 30px;" v-for="surcharge in data.surcharges" :key="surcharge">
              <div class="data-set data-set--reversed">
                <div class="data-set-title">{{ surcharge.title }}:</div>
                <div class="data-set-content">{{ surcharge.value }} {{ data?.currency }}</div>
              </div>
            </div>
          </div>
        </span>
      </div>
      <div class="stockDeliverFrame">
        <span>
          <p>
            {{ $t("profile.stock.driver") }}
          </p>
          <span>{{ data.department ? data.department.name : "-" }}</span>
        </span>
        <!-- 
        <span>
          <p>{{ $t("profile.stock.disposal") }}</p>
          <span> {{ data.departmentLoader ? data.departmentLoader.name : "-" }}</span>
        </span> -->
        <span>
          <p>{{ $t("profile.stock.changelog.flatrate") }}</p>
          <span> {{ data.flatRate ?? '-' }}</span>
        </span>
        <span>
          <p>{{ $t("profile.stock.numberOfPilots") }}</p>
          <span> {{ data.numberOfPilots }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { convertLongStringToDateAndHour } from "@/js/date.utils";
import router from "@/router";
export default {
  name: "OrderInfo",
  props: {
    title: String,
    data: Object,
    avatar: String,
  },
  components: {},
  setup(props) {
    return { convertLongStringToDateAndHour, router };
  },
};
</script>

<style lang="scss" scoped>
@use "@/css/stock/stockComponents.scss";

.stockDeliverBox {
  background: #fff;
  border-radius: 20px;
  position: relative;
}

.stockDeliverInnerBox {
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 500px) {
    margin: 0;
    padding: 0;
  }
}
.place-info {
  display: flex;
  padding: 10px 3px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px;
  text-align: left !important;
  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgb(158, 155, 155);
    width: 100px;
  }
  .data {
    font-size: 16px;
    font-weight: 400;
    margin-left: 20px;
  }
}
.avatar-photo {
  width: 110px !important;
  justify-self: flex-start;
  margin-right: auto;
}
</style>
